import { makeStyles } from '@material-ui/core/styles';
import Badge from '@mui/material/Badge';
import { generatePath } from '@ps/web-core-utils';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import StarsNavigation, { Variant } from '@swf/components/StarsNavigation/StarsNavigation';
import StarsNavigationItem from '@swf/components/StarsNavigation/StarsNavigationItem';
import { ThemeMode } from '@swf/core/enums';
import { select } from '@swf/core/store';
import { useWidgetTheme } from '@swf/poker';

import type { NavLink } from '../../types/common';

import styles from './MainNav.scss';

export interface Props {
  active?: boolean;
  links?: NavLink[];
  className?: string;
  innerClassName?: string;
  navItemClassName?: string;
}

const useStylesBadge = makeStyles((theme) => ({
  badge: {
    backgroundColor: '#02BD9C',
    top: '30% !important'
  }
}));

const MainNav = ({ links, className, innerClassName, navItemClassName }: Props) => {
  const { themeMode } = useWidgetTheme();
  const { pathname } = useLocation();
  const aliases = useSelector(select.cms.getAliases);
  const classes = useStylesBadge();

  if (!links || !links.length) return null;

  return (
    <StarsNavigation
      className={classNames(styles.container, className)}
      innerClassName={classNames(styles.innerContainer, innerClassName)}
      variant={themeMode === ThemeMode.Light ? Variant.Light : Variant.Dark}
    >
      {links.map(({ active, translation, alias, notification, values = {} }) => (
        <Badge
          invisible={!notification?.visible || active}
          overlap="circular"
          badgeContent={notification?.content}
          variant={notification?.variant}
          key={translation.id}
          classes={classes}
        >
          <StarsNavigationItem
            alias={alias}
            values={values}
            className={classNames(styles.navItem, navItemClassName)}
            isActive={() =>
              active ?? pathname.includes(generatePath(aliases?.[alias ?? ''] ?? '', values))
            }
          >
            <Translation {...translation} />
          </StarsNavigationItem>
        </Badge>
      ))}
    </StarsNavigation>
  );
};

export default MainNav;
